/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */

'use strict';

module.exports = Odigeo.View.extend({

    init: function() {
        this.bindEvents();
    },

    bindEvents: function() {
        this.listenTo(this.model, 'showLightboxWarning', this.showLightboxWarning);
    },

    showLightboxWarning: function() {
        Odigeo.trigger(this.widget.id + ':cancelMembershipWithError', {action: 'cancelMembershipWithError'});
        Odigeo.UIElements.showLightboxWarning('od-passenger-lightbox-edit',
            Odigeo._.bind(Odigeo._.noop, this),
            Odigeo._.bind(Odigeo.trigger, Odigeo, 'closeAllPopUps'),
            Odigeo.UIElements.translations.membershipManager.lightboxTexts, true);
    },
});
